import { Component, OnInit } from '@angular/core';
import { AuthService } from "../../../services/auth.service";
declare const toggleSideBar: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(public authService: AuthService) { }

  ngOnInit(): void {
  }
  sidebar() {
    toggleSideBar();
  }

}
